import styled from 'styled-components'

export const StyledStepTemplates = styled.div`
  height: 100%;
  .ant-form {
    height: 100%;
  }
`
